import React from "react";
import { CrossIcon } from "../../../SvgIcons/allIcons";
import Barcode from 'react-barcode';
const QRBar = ({ handleRemoveObject, element, preview }) => {
  if (preview) {
    const hasValue =
      element?.value &&
      String(element.value).trim() !== "0" &&
      element.value !== 0;
    const hasImage =
      element?.src &&
      (element.src.includes("https") ||
        element.src.includes("http") ||
        element.src.startsWith("blob:") ||
        element.src.startsWith("data:image"));

    return (
      <div className=" h-100 position-relative afterPreview">
        <div className="dropzone">
          <div className="image-preview h-100 w-100 p-1">
            {hasValue ? (
              <div className="preview_barcode">
                <Barcode format="UPC" value={String(element.value)} />
              </div>
            ) : hasImage ? (
              <img
                src={element.src}
                alt="Preview"
                className="label-after-image"
                height={element.styles.height - 15}
                width={element.styles.width - 15}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="file_Upload h-100 position-relative">
      <span
        className="cross-icon-label"
        role="button"
        onClick={() => handleRemoveObject(element.id)}
      >
        <CrossIcon size={13} />
      </span>

      <div className="dropzone">
        <div className="image-preview h-100 w-100 p-1">
          <img
            src={element.src}
            alt="Preview"
            className="label-after-image"
            height={element.styles.height - 15}
            width={element.styles.width - 15}
          />
        </div>
      </div>
    </div>
  );
};

export default QRBar;
